import * as fs from "node:fs/promises";
import * as path from "node:path";
import { stripIndent } from "common-tags";
import * as prettier from "prettier";
import { decodePrismicConfig } from "./lib/decodePrismicConfig.js";
const createPluginSystemHelpers = (project) => {
  return new PluginSystemHelpers(project);
};
class PluginSystemHelpers {
  /**
   * Project's metadata.
   *
   * @internal
   */
  _project;
  constructor(project) {
    this._project = project;
  }
  getProject = async () => {
    const configFilePath = this.joinPathFromRoot("prismic.config.json");
    let rawConfig;
    try {
      const contents = await fs.readFile(configFilePath, "utf8");
      rawConfig = JSON.parse(contents);
    } catch {
    }
    if (!rawConfig) {
      throw new Error("No Prismic config found, please initialize your project with first.");
    }
    const { value: prismicConfig, error } = decodePrismicConfig(rawConfig);
    if (error) {
      throw new Error(`Invalid Prismic config. ${error.errors.join(", ")}`);
    }
    return {
      ...this._project,
      config: prismicConfig
    };
  };
  updatePrismicConfig = async (prismicConfig, options) => {
    const { value: decodedPrismicConfig, error } = decodePrismicConfig(prismicConfig);
    if (error) {
      throw new Error(`Invalid Prismic config provided. ${error.errors.join(", ")}`);
    }
    const configFilePath = this.joinPathFromRoot("prismic.config.json");
    let content = JSON.stringify(decodedPrismicConfig, null, 2);
    if (options?.format) {
      content = await this.format(content, configFilePath);
    }
    await fs.writeFile(configFilePath, content);
  };
  format = async (source, filePath, options) => {
    let formatted = stripIndent(source);
    const prettierOptions = await prettier.resolveConfig(filePath || this._project.root);
    formatted = await prettier.format(formatted, {
      ...prettierOptions,
      filepath: filePath,
      ...options?.prettier ?? {}
    });
    if (options?.includeNewlineAtEnd === false) {
      formatted = formatted.replace(/[\r\n]+$/, "");
    }
    return formatted;
  };
  joinPathFromRoot = (...paths) => {
    return path.join(this._project.root, ...paths);
  };
}
export {
  PluginSystemHelpers,
  createPluginSystemHelpers
};
//# sourceMappingURL=createPluginSystemHelpers.js.map
